export default class City {
    constructor(_id, city, region_id, region_name) {
      this._id = _id;
      this.city = city;
      this.region_id = region_id;
      this.region_name = region_name;
    }
  
    // Метод для парсинга JSON в объект City
    static fromJson(json) {
      return new City(json._id, json.city, json.region_id, json.region_name);
    }
}